<template>
  <div class="regular-header">
  <navbar />
  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>Avans Hogeschool</h1>
      <p>Onze samenwerking met Avans Hogeschool is er een waar wij erg trots op zijn. Alles omtrent educatie en zorgen voor een betere leeromgeving is iets dat erg belangrijk voor ons is. Gedurende onze samenwerking hebben wij een drietal animaties ontwikkeld waarin we toekomstvisies verbeelden en voortdurend streven naar kwaliteit binnen de organisatie. </p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>    
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>

  </halfBanner> 

<div class="case-page">

  <titel>
    <template v-slot:intro-tekst>
      <h2>Generatie-Z</h2>
      <p>Avans wil zich in hun nieuwe visie gaan richten op de volgende generatie van leerlingen, generatie-Z. Deze generatie is opgegroeid met het internet en alle mobiele apparaten en diensten die daarbij horen. Zo hoort ook onderwijs digitaal te gaan en om deze visie in kaart te brengen hebben wij hier een informatieve animatie voor ontwikkeld.</p>
    </template>
  </titel>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/avanshogeschool/Folded_Paper_Werk_Avans_image_1.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Educatie los van locatie</h3>
          <p>Onderwijs blijft zich ontwikkelen en Avans gaat hierin mee. Zij zijn er van overtuigd dat onderwijs niet locatie gebonden is. De ambitie voor een online leerportaal is dan ook niet zo gek. Leerlingen kunnen bijvoorbeeld online een extra curicullum volgen tijdens hun stage in Berlijn.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case even">
      <div class="text-box">
        <div class="content padding-left">
          <h3>Student en docent</h3>
          <p>Bij zo’n online leerportaal wordt er veel verwacht van de student maar ook zeker van de docenten. Buiten hun reguliere les-uren wordt er ook tijd vrijgemaakt om via het leerportaal studenten over de hele wereld te kunnen begeleiden. Dit kunnen kleinere ‘klassen’ zijn maar zorgt daarmee ook voor meer één op één begeleiding om de studenten zo gericht mogelijk les te geven.</p>
        </div>
      </div>
         <div class="img-box">
        <img src="../../assets/cases/avanshogeschool/Folded_Paper_Werk_Avans_image_2.jpg">
      </div>
    </div>
  </oddEvenGrid>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>De toekomst in digitaal</h2>
    <p>Om te laten zien dat de wereld om ons heen veranderd en tegenwoordig alles on demand is laten wij op een futuristische manier zien hoe de docenten en studenten van de toekomst interacteren met hun leeromgeving. Dit kan middels livestreams, ingevlogen drones of zwevende displays waarbij je snel inzicht krijgt in je studievoortgang.</p>
  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/avanshogeschool/Folded_Paper_Werk_Avans_image_3.jpg">
  </template>
</titelPictureBig>

<titelVideoBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Boost-it</h2>
    <p>Deze animatie laat zien dat docenten en studenten niet gebonden zijn aan tijd en / of locatie. Hier leggen wij uit hoe onderwijs voor de volgende generatie vorm kan gaan krijgen en wat deze  veranderingen betekenen voor de toekomst van het onderwijs binnen Avans.</p>
  </template>
  <template v-slot:case-img>
    <div class="embed-container">
    <iframe src="https://player.vimeo.com/video/279802560" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>
  </template>
</titelVideoBig>


<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Kwaliteit in beweging</h2>
    <p>Kwaliteit staat hoog in het vaandel bij Avans. Om deze kwaliteit staande te houden en te verbeteren is het belangrijk om inhoudsrijke gesprekken te voeren. Binnen deze animatie leggen wij de focus op de mensen waar deze gesprekken mee gevoerd worden maar ook hoe deze gesprekken worden aangepakt om de kwaliteit te verbeteren.</p>
  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/avanshogeschool/Folded_Paper_Werk_Avans_image_4.jpg">
  </template>
</titelPictureBig>

<titelVideoBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Het inhoudsrijke gesprek</h2>
    <p>Om beeld te geven bij het inhoudsrijke gesprek hebben wij een animatie gemaakt waarbij de stakeholders die de gesprekken voeren centraal staan. Het is belangrijk voor Avans om te laten zien dat dit niet alleen maar om de docenten gaat maar ook om externe partijen die gebonden zijn aan Avans. Het is ook belangrijk dat deze gesprekken niet gebonden zijn aan locatie maar overal plaats kunnen vinden.</p>
  </template>
  <template v-slot:case-img>
    <div class="embed-container">
<iframe src="https://player.vimeo.com/video/251069630" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>
  </template>
</titelVideoBig>



<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Onderwijslogistiek</h2>
    <p>Avans Hogeschool ziet dat de wereld niet stil staat. Om aan te geven dat meegaan met de toekomst erg belangrijk is voor het onderwijs hebben wij op een futuristische back to the future achtige manier in beeld gebracht hoe dit vorm zou kunnen krijgen. Robots die faciliteren in onderwijs maar ook online devices die de student makkelijk hun rooster kan laten inzien en aanpassen.</p>
  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/avanshogeschool/Folded_Paper_Werk_Avans_image_5.jpg">
  </template>
</titelPictureBig>

<titelVideoBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Avans goes future proof</h2>
    <p>In 2020 - 2024 wil Avans zich nog meer gaan focussen op studeerbaar, doceerbaar, organiseerbaar en betaalbaar onderwijs. In deze animatie laten wij zien hoe flexibel de hogeschool is en wat die flexibiliteit betekend voor de toekomst.</p>
  </template>
  <template v-slot:case-img>
    <div class="embed-container">
<iframe src="https://player.vimeo.com/video/208984201" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>
  </template>
</titelVideoBig>


<endCase v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>Avans samengevat</h2>
    <p>Avans Hogeschool heeft altijd de behoefte om vernieuwing te communiceren en wij willen hier altijd bij inspringen wanneer dit nodig is. Zoals we al zeiden in het begin is onderwijs erg belangrijk voor ons, en dat mogen visualiseren voor zo’n organisatie is natuurlijk te gek!</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/Folded_Paper_Werk_Thanks.jpg">
  </template>
  <template v-slot:outro-tekst>
    <h4>Bekijk ook onze andere toffe cases</h4>
  </template>
</endCase>

 <caseGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
    <div class="row">
      <ul>
        <li>
          <router-link class="router-link" to="/werk/wageningen-universiteit">
            <div class="column tca">
              <img src="../../assets/Folded_Paper_case_thumnail_Unlock.jpg">
              <span class="font-size-custom-max-12">Unlock Wageningen Universiteit & Research<br>Branding & product design</span>
            </div>
           </router-link>
        </li>

         <li>
          <router-link class="router-link" to="/werk/mobilyze">
            <div class="column avans">
              <img src="../../assets/Folded_Paper_case_thumbnail_Mobilyze.jpg">
              <span class="font-size-custom-max-12">Mobilyze <br>Branding & product design</span>
            </div>
          </router-link>
          </li>
    </ul>
  </div>
</caseGrid>


</div>
<footerComponent></footerComponent>
</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import halfBanner from '@/components/generalLayout/halfBanner.vue';
import titel from '@/components/generalLayout/werk/titel.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import titelPictureMedium from '@/components/generalLayout/werk/titelPictureMedium.vue';
import titelPictureBig from '@/components/generalLayout/werk/titelPictureBig.vue';
import titelVideoBig from '@/components/generalLayout/werk/titelVideoBig.vue';
import endCase from '@/components/generalLayout/werk/endCase.vue';
import fullWidthPicture from '@/components/generalLayout/werk/fullWidthPicture.vue';
import backgroundPattern from '@/components/generalLayout/werk/backgroundPattern.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

import Lottie from '../../lottie.vue';
import * as animationAvansHogeschool from '@/assets/cases/avanshogeschool/headeranimatie/avanshogeschool.json';


export default {
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationAvansHogeschool.default}, string:'Illustratie / Animatie', },
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    titel,
    oddEvenGrid,
    titelPictureMedium,
    titelPictureBig,
    titelVideoBig,
    endCase,
    fullWidthPicture,
    backgroundPattern,
    caseGrid,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}

</script>

<style lang="scss">

.home-bg-color{
  background: rgba(255,30,61,0.15) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

body .case .img-box img, .odd-even-grid .text-box img{
  max-height: 600px !important;
  width: auto !important;
  margin:  auto;
  display: block;
}

.case-content{
  h2{
    padding-top: layout-val-64(0.5);
    padding-bottom: layout-val-8(1);
  }
}

.case-img-bg{
  background-color: #FFF8E7;
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}

</style>
